import { STUDENT_LIST_RECENCY_ACTIVE_WITHIN_DAYS } from '../constants/studentList';

/**
 * Whether the student list should show **Active** (vs Inactive) from
 * `StudentProfile.listRecencyDate` (attendance + booking activity; see backend enrich).
 */
export function isStudentListRecencyActive(
  listRecencyDate: string | Date | null | undefined,
  now: Date = new Date()
): boolean {
  if (listRecencyDate == null) {
    return false;
  }
  const d =
    typeof listRecencyDate === 'string'
      ? new Date(listRecencyDate)
      : listRecencyDate;
  if (Number.isNaN(d.getTime())) {
    return false;
  }
  const cutoff = new Date(now);
  cutoff.setDate(cutoff.getDate() - STUDENT_LIST_RECENCY_ACTIVE_WITHIN_DAYS);
  cutoff.setHours(0, 0, 0, 0);
  const compare = new Date(d);
  compare.setHours(0, 0, 0, 0);
  return compare >= cutoff;
}
